import React from 'react'
import { Text } from '../../themes/userq/Text/Text'
import { Icon } from '../../themes/userq/Icon/Icon'

export default function BrowserNotSupported(){

return(
<div className='full-screen'>

<div className='text-center'>
<div className='mb-20 d-flex justify-content-center'><Icon size={'large'} value={'error'} colorClass={'danger-200-svg'}  /></div>

<Text type={'subtitle-2'} >Browser not supported </Text>
<Text type={'body-text-2'} fontWeight={'medium-font'} cssClasses={'mt-20 gray-text'}>This study is only available on <span className='semibold-font dark-text'>Google Chrome.</span></Text>
<Text type={'body-text-2'} fontWeight={'medium-font'} cssClasses={'gray-text'}>Please access the study on <span className='semibold-font dark-text'>Google Chrome</span> to be able to participate.</Text>


</div>

</div>
)
}